// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"9efd15e310cd86757dff","655":"4ca82b563e9711217164"}[chunkId] + ".js";
};